import { useCallback } from 'react'

import { GlobalTask } from '@/store/globalTaskSlice'
import { useAppStore } from '@/store/useAppStore'

type CreateTaskOptions = Omit<GlobalTask, 'startTime'>

const useGlobalTask = () => {
  const addGlobalTask = useAppStore.use.addGlobalTask()
  const updateGlobalTask = useAppStore.use.updateGlobalTask()
  const removeGlobalTask = useAppStore.use.removeGlobalTask()
  const clearAllTasks = useAppStore.use.clearAllTasks()
  const getActiveTask = useAppStore.use.getActiveTask()

  // Convenience method to run a task with automatic cleanup
  const runTask = useCallback(
    async <T>(
      taskOptions: CreateTaskOptions,
      taskFn: () => Promise<T>
    ): Promise<T> => {
      addGlobalTask(taskOptions)

      try {
        const result = await taskFn()
        return result
      } finally {
        removeGlobalTask(taskOptions.id)
      }
    },
    [addGlobalTask, removeGlobalTask]
  )

  return {
    addTask: addGlobalTask,
    updateTask: updateGlobalTask,
    removeTask: removeGlobalTask,
    clearAllTasks,
    getActiveTask,
    runTask,
  }
}

export default useGlobalTask
